<footer>
  <div class="container-fluid footer-section">
    <div class="inner">
      <a href="/" class="logo">JTS</a>
      <div class="subject">
        JTS is an international relief organization that is in<br />
        special consultative status with UN ECOSOC
      </div>
      <div class="address2">
        Join Together Society&nbsp;&nbsp;&nbsp;Phone: +82 2 587 8995&nbsp;&nbsp;&nbsp;Fax: +82 2 587 8998<br />
        11th Floor, Seoul Jungto Center Bldg, 42, Hyoryeong-ro 51-gil, Seocho-gu, Seoul, Korea
      </div>
      <hr class="line" />
      <div class="address">
        JTS Ansan Multicultural Center&nbsp;&nbsp;&nbsp;Phone: +82 31 495 8995<br />
        5th Floor, 82, Singil-ro 1-gil, Danwon-gu, Ansan-si, Gyeonggi-do, Korea
      </div>
      <div class="address3">
        JTS AMERICA&nbsp;&nbsp;&nbsp;Phone: +1 301 655 9150&nbsp;&nbsp;&nbsp;Email: jtsamerica&#64;jtsint.org<br />
        4361 Aitcheson Rd. Beltsville, MD 20705
      </div>
      <div class="copyright">Copyright 2022 © JTS. All Rights Reserved</div>
      <div class="sns">
        <a href="https://www.youtube.com/user/jtskorea" alt="youtube" class="item youtube" target="_blank">youtube</a>
        <a href="https://www.facebook.com/jtskorea" alt="facebook" class="item fb" target="_blank">facebook</a>
        <a href="https://www.instagram.com/jts_korea" alt="instagram" class="item insta" target="_blank">instagram</a>
        <a href="https://pf.kakao.com/_Iuxhxgxb" alt="kakao channel" class="item kakao" target="_blank"
          >kakao channel</a
        >
        <a href="https://blog.naver.com/jtskorea_" alt="naver blog" class="item blog" target="_blank">naver blog</a>
        <a
          href="https://happylog.naver.com/hlog/jtstogether/home"
          alt="happy bean"
          class="item happybean"
          target="_blank"
          >happy bean</a
        >
      </div>
    </div>
  </div>
</footer>
